import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { TiptapVuetifyPlugin } from 'tiptap-vuetify';
import 'tiptap-vuetify/dist/main.css';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        purple: '#6A73DF',
        blue: '#66CCFF',
        blueLighten: '#EEEFFF',
        blueDarken: '#4253BA',
        indigoDarken: '#333466',
        greyDarken: '#757575',
        deepPurpleLighten: '#C2C6FF',
        peach: '#FFCC33',
        red: '#E55151',
      },
    },
  },
});

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'mdi',
});

export default vuetify;
